import Styled, { css } from "styled-components";
const PictureTagBase = Styled.img `
	position: absolute;
	z-index: 2;
`;
export const RightTopTag = Styled(PictureTagBase) `
	height: auto;
	top: 0;
	right: 0;
	${(props) => {
    switch (props.gridCol) {
        case 1:
            return css `
					max-width: 1.6875rem;
					max-height: 1.6875rem;
				`;
        case 2:
            return css `
					max-width: 1.875rem;
					max-height: 1.875rem;
				`;
    }
    return "";
}}
`;
export const LeftTopTag = Styled(PictureTagBase) `
	top: 0;
	left: 0;
	${(props) => {
    switch (props.gridCol) {
        case 1:
            return css `
					max-height: 0.875rem;
				`;
        case 2:
            return css `
					max-height: 2.5rem;
					max-width: 47%;
				`;
    }
    return "";
}}
`;
export const LeftBottomTag = Styled(PictureTagBase) `
	height: 1.375rem;
	bottom: 0;
	left: 0;
`;
